import { type Verdict as VerdictType, Verdict } from '@exam-room/graphql/preview';
import { useTranslation } from '@exam-room/translations';

import { CancelOutlinedIcon, CheckCircleOutlinedIcon } from '../../../../components';

interface VerdictLabelProps {
  verdict?: VerdictType | null;
}

export default function VerdictLabel(props: Readonly<VerdictLabelProps>) {
  const { verdict } = props;

  const { t } = useTranslation();

  let icon: JSX.Element | null = null;
  let label = t('examPreview.reviewResultSection.notSpecified');

  if (verdict === Verdict.Approved) {
    icon = <CheckCircleOutlinedIcon className='text-success text-xl' />;
    label = t('examPreview.reviewResultSection.agree');
  } else if (verdict === Verdict.Rejected) {
    icon = <CancelOutlinedIcon className='text-danger text-xl' />;
    label = t('examPreview.reviewResultSection.disagree');
  }

  return (
    <div className='text-text-secondary flex w-fit items-center gap-2 rounded-lg bg-gray-100 px-4 py-2.5'>
      {icon}
      <span className='text-sm'>{label}</span>
    </div>
  );
}
